import { useState, useEffect } from 'react';
import axios from 'axios';
import { logger } from '../utils/logger';
import useTrialExpirationHandler from './useTrialExpirationHandler';

export interface Account {
  id: string;
  name: string;
  description?: string;
  sector: string | { id: string; name: string; slug?: string } | null;
  organizationId: string;
  createdAt: string;
}

const useAccounts = () => {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [loading, setLoading] = useState(true); // Start true to prevent race conditions
  const { handleApiError: handleTrialApiError } = useTrialExpirationHandler();

  const fetchAccounts = async () => {
    try {
      setLoading(true);
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

      const response = await axios.get(`${API_URL}/api/accounts`, {
        withCredentials: true
      });
      
      setAccounts(response.data.accounts);
      return response.data.accounts;
    } catch (error) {
      // Handle trial expiration error
      if (handleTrialApiError(error)) {
        setAccounts([]); // Return empty array if trial expired
        return [];
      }
      
      logger.error('Error fetching accounts:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAccounts();
  }, []);

  return {
    accounts,
    loading,
    refetch: fetchAccounts
  };
};

export default useAccounts; 